import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";
import { useNavigate,useLocation   } from 'react-router-dom';
import { Link } from 'react-router-dom'; 


import {
  HomeImageContainer
  , HomeContainer, HomeImage, HomeLoginContainer, FlexBox, LoginHeader, InputField,
  InputBox, LoginButton, EmptyBox, LoginButtonContainer,BackToLogin
} from './styled';
import { Header } from '../../components/header/internals'
import Image from '../../assets/homeimage.svg'
 


export const NewPassword = (props:any) => {
  const [formFields, setFormFields] = useState({  password: '',confirmPassword:''})
  const [errorField, setErrorField] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<any>(false);
  const [isValidate, setIsValidate] = useState<any>(true);
  const navigate = useNavigate();
  const location = useLocation();

   
  const errorStyle = { 
    borderColor: 'red', 
  };
  useEffect(() => {
    validateRequestId();
  }, []);

  const showToastMessage = (message: any) => {
    apiClient.showErrorMessage(message);
  };
  const showSuccessMessage = (message: any) => {
    apiClient.showSuccessMessage(message);
  };
  
  const handleOnChange = (event: any, identifier: any) => {
    let fields: any = { ...formFields };
    fields[identifier] = event.target.value;
    setErrorField(null);
    setFormFields(fields);

  };

  const validateRequestId=()=>{ 
  const queryParams = new URLSearchParams(location.search);  
  const requestId = queryParams.get('request_id');  
  setIsValidate(true);
  apiClient.get(`app-users/validforgotpassword/${requestId}`,null).then((response: any) => {
    setIsValidate(false); 
      if(response.result)
      {
        //showSuccessMessage(response.message);
        //navigate('/reset');    
      }
      else
      {
        
        showToastMessage(response.message);
        navigate('/home');    
      }
    }).catch((err) => {
      setIsValidate(false);
    })
  }

  const handleSubmit = () => { 
    if (formFields.password == null || formFields.password == undefined || formFields.password == '') {
      showToastMessage('Password is required');
      setErrorField('password')
      return;
    }
    if (formFields.confirmPassword == null || formFields.confirmPassword == undefined || formFields.confirmPassword == '') {
      showToastMessage('Confirm Password is required');
      setErrorField('confirmPassword')
      return;
    }
    if (formFields.confirmPassword != formFields.password) {
      showToastMessage('Confirm Password is not matching with password');
      setErrorField('confirmPassword')
      return;
    }
    setIsLoading(true);
    const queryParams = new URLSearchParams(location.search);  
    const requestId = queryParams.get('request_id');  
    let payload={ 
      password:   formFields.password,
      request_Id:requestId, 
    }
    apiClient.post('app-users/resetpassword', payload,null).then((response: any) => {
      setIsLoading(false); 
      if(response.result)
      {
        showSuccessMessage(response.message);
        navigate('/home');    
      }
      else
      {
        showToastMessage(response.message);
      }
    }).catch((err) => {
      setIsLoading(false);
    })
  }

  return (
    <HomeContainer>
      <Header />
      
      <FlexBox >
        <HomeImageContainer>
          <HomeImage src={Image} />
        </HomeImageContainer>

       {!isValidate && <HomeLoginContainer>
          <LoginHeader>
            New Password
          </LoginHeader>
          <InputField style={errorField=='password'?errorStyle:{}} >
            <InputBox type="password" placeholder='Enter New Password' value={formFields.password} onChange={(event) => handleOnChange(event, 'password')} ></InputBox>
          </InputField>
          <InputField style={errorField=='confirmPassword'?errorStyle:{}} >
            <InputBox type="password" placeholder='Enter Confirm Password' value={formFields.confirmPassword} onChange={(event) => handleOnChange(event, 'confirmPassword')}></InputBox>
          </InputField>
           <BackToLogin>
            <Link style={{
              color: '#4285F4', textDecoration: 'none',
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '20px',
              paddingLeft: '5px',
              cursor: 'pointer'
            }} to={'/home'}>Back To Login</Link>   </BackToLogin>
          
          
          <EmptyBox />
          <LoginButtonContainer>
            <LoginButton disabled={isLoading} onClick={handleSubmit} >Change</LoginButton>
          </LoginButtonContainer>
        </HomeLoginContainer>
}

      </FlexBox>

    </HomeContainer>
  );
};
